import { loadDismissablePromptsByType } from '@ms/yammer-data/dist/domains/dismissablePromptsByType/actions';
import { DismissablePromptType } from '@ms/yammer-data/dist/state/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export type UseLoadDismissablePromptsByType = (types: DismissablePromptType[]) => void;
export const useLoadDismissablePromptsByType: UseLoadDismissablePromptsByType = (types) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadDismissablePromptsByType(types));
  }, [dispatch, types]);
};
